/* eslint-disable react/prop-types */
/**
 * @file Pressure.jsx
 * @exports PressureDefault
 */
import React from 'react'
import High from './High'
import Low from './Low'
import Time from './Time'

const defaultColor = '#284047'

const PressureDefault = function PressureDefault ({ high, low, style, time }) {
  return (<Pressure high={high} low={low} style={style} time={time} />)
}

export default PressureDefault

const Pressure = function Pressure ({ high, low, style, time }) {
  const svgStyle = style || { fill: defaultColor }
  const lineStyle = {
    fill: 'none',
    fillOpacity: 1,
    stroke: defaultColor,
    strokeWidth: 2,
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
    strokeMiterlimit: 4,
    strokeDasharray: 'none',
    strokeOpacity: 1
  }

  const markStyle = {
    strokeWidth: 1.5,
    strokeLinecap: 'square',
  }

  const needleStyle = {
    strokeWidth: 1.5,
  }

  return (
    <svg
      style={svgStyle}
      id='pressure-icon'
      viewBox='0 0 75 75'
      version='1.1'
    >
      <description>pressure icon</description>
      <title>pressure</title>
      <g
        fill='#284047'
        style={{
          transform: 'translate(20px, 10px)',
        }}
      >
        <path d='M25.8 27c-.2 0-.4-.1-.5-.2-.3-.3-.3-.8 0-1.1 2-2.1 3.2-4.9 3.2-7.9s-1.2-5.8-3.2-7.9-4.8-3.3-7.7-3.3-5.7 1.2-7.7 3.3-3.2 4.9-3.2 7.9 1.2 5.8 3.2 7.9c.3.3.3.8 0 1.1s-.8.3-1.1 0c-2.3-2.4-3.7-5.6-3.7-9s1.3-6.6 3.7-9S14.1 5 17.5 5s6.5 1.4 8.8 3.7 3.7 5.6 3.7 9-1.3 6.6-3.7 9c-.1.2-.3.3-.5.3z' />
        <path d='M14.9 17.5l-2.5 1.1c-.4.2-.6.6-.4 1 .3.4.7.5 1.1.4l2.5-1c.8.7 1.9.9 2.9.5 1.3-.5 1.9-1.8 1.3-3.1-.6-1.1-2-1.7-3.4-1.1-1 .4-1.5 1.3-1.5 2.2zm3.3-.5c.3.4.1.8-.4 1-.4.2-.9.1-1.1-.4-.3-.4-.1-.8.4-1 .5-.2.9 0 1.1.4z' />
        <path d='M35 17.7C35 7.9 27.1 0 17.5 0S0 7.9 0 17.7c0 8.1 5.4 14.9 12.7 17v4.7H9.5c-.5 0-.8.3-.8.8v7.2c0 .5.3.8.8.8h2.4v4c0 .5.3.8.8.8h9.5c.5 0 .8-.3.8-.8v-4h2.4c.5 0 .8-.3.8-.8v-3.2h.8v1.6c0 .5.3.8.8.8s.8-.3.8-.8V41c0-.5-.3-.8-.8-.8s-.8.3-.8.8v1.6h-.8v-2.4c0-.5-.3-.8-.8-.8h-3.2v-4.7c7.4-2.2 12.8-8.9 12.8-17zm-33.4 0c0-8.8 7.2-16.1 15.9-16.1s15.9 7.2 15.9 16.1c0 7.5-5.2 13.9-12.2 15.6-.4.1-.8.2-1.2.2-.2.1-.5.1-.7.1-.2 0-.4 0-.6.1-.4 0-.8.1-1.2.1h-.2c-.4 0-.8 0-1.2-.1-.2 0-.4 0-.6-.1-.2 0-.5-.1-.7-.1-.4-.1-.8-.2-1.2-.2-6.8-1.7-12-8.1-12-15.6zm19.9 33.7h-8v-3.2h8v3.2zm3.2-4.8h-1.6v-3.2c0-.5-.3-.8-.8-.8s-.8.3-.8.8v3.2h-1.6v-3.2c0-.5-.3-.8-.8-.8s-.8.3-.8.8v3.2h-1.6v-3.2c0-.5-.3-.8-.8-.8s-.8.3-.8.8v3.2h-1.6v-3.2c0-.5-.3-.8-.8-.8s-.8.3-.8.8v3.2h-1.6V41H24.7v5.6zm-4-7.3h-6.4V35c1 .2 2.1.3 3.2.3s2.1-.1 3.2-.3v4.3z' />
        <path d='M17 10c-.6 0-1-.3-1-.8V7.8c0-.5.4-.8 1-.8s1 .3 1 .8v1.5c0 .4-.4.7-1 .7z' />
        <path d='M12.1 13c-.3 0-.4-.1-.6-.3l-1.2-1.2c-.4-.4-.4-.9 0-1.2.4-.4.9-.4 1.2 0l1.2 1.2c.4.4.4.9 0 1.2-.1.2-.3.3-.6.3z' />
        <path d='M9.2 18H7.8c-.5 0-.8-.4-.8-1s.3-1 .8-1h1.5c.4 0 .8.4.8 1s-.4 1-.9 1z' />
        <path d='M10.9 25c-.3 0-.4-.1-.6-.3-.4-.4-.4-.9 0-1.2l1.2-1.2c.4-.4.9-.4 1.2 0 .4.4.4.9 0 1.2l-1.2 1.2c-.2.2-.4.3-.6.3z' />
        <path d='M24.1 25c-.3 0-.4-.1-.6-.3l-1.2-1.2c-.4-.4-.4-.9 0-1.2s.9-.4 1.2 0l1.2 1.2c.4.4.4.9 0 1.2-.1.2-.4.3-.6.3z' />
        <path d='M26.2 18h-1.5c-.5 0-.8-.4-.8-1s.3-1 .8-1h1.5c.5 0 .8.4.8 1s-.3 1-.8 1z' />
        <path d='M22.9 13c-.3 0-.4-.1-.6-.3-.4-.4-.4-.9 0-1.2l1.2-1.2c.4-.4.9-.4 1.2 0 .4.4.4.9 0 1.2l-1.2 1.2c-.2.2-.4.3-.6.3z' />
        <path d='M20.2 55h-6.4c-.5 0-.8-.4-.8-1s.3-1 .8-1h6.4c.5 0 .8.4.8 1s-.3 1-.8 1z' />
      </g>

      {high && (
        <g id='high' transform='translate(40, 40) scale(.4)'>
          <High />
        </g>
      )}

      {low && (
        <g id='low' transform='translate(40, 40) scale(.4)'>
          <Low />
        </g>
      )}

      {time && (
        <g id='time' transform='translate(23,20) scale(.7)'>
          <Time />
        </g>
      )}
    </svg>
  )
}
